export class Filter {
  identifier: number;
  not: boolean;
  constructor(public code: string) {}
}
